import { FC } from "react";
import { Skeleton, Stack, Typography, styled } from "@mui/material";
import AddAttackCard from "./AddAttackCard";
import AttackCard from "./AttackCard";
import { Attack, SuspectedHeadacheType } from "../../types";
import { DateTime } from "luxon";

const LoadingCard = styled(Skeleton)({
  height: "3rem",
  margin: "0.5rem 0",
});

interface HeadacheAttacksProps {
  attacksLoaded: boolean;
  attacks: Attack[];
  addAttack: (newAttack: {
    startDateTime: DateTime;
    endDateTime: DateTime;
    awake: boolean;
    disabledForTwoHours: boolean;
    suspectedHeadacheType: SuspectedHeadacheType;
    notes: string;
  }) => void;
  editAttack: (
    attackId: number,
    newAttack: {
      startDateTime: DateTime;
      endDateTime: DateTime;
      awake: boolean;
      disabledForTwoHours: boolean;
      suspectedHeadacheType: SuspectedHeadacheType;
      notes: string;
    },
  ) => void;
  deleteAttack: (attackId: number) => void;
}

const HeadacheAttacks: FC<HeadacheAttacksProps> = ({
  attacksLoaded,
  attacks,
  addAttack,
  editAttack,
  deleteAttack,
}) => (
  <Stack spacing={1}>
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="h6">Headache Attacks</Typography>
      <AddAttackCard addAttack={addAttack} />
    </Stack>
    {!attacksLoaded ? (
      <>
        <LoadingCard variant="rounded" />
        <LoadingCard variant="rounded" />
        <LoadingCard variant="rounded" />
      </>
    ) : attacks.length ? (
      <>
        {attacks.map((attack) => (
          <AttackCard
            key={attack.attackId}
            attack={attack}
            editAttack={editAttack}
            deleteAttack={deleteAttack}
          />
        ))}
      </>
    ) : (
      <Typography textAlign="center">
        This patient has no recorded headache attacks.
      </Typography>
    )}
  </Stack>
);

export default HeadacheAttacks;
